import { publishFormSubmitted } from 'utils/form-analytics';
import { watchKlaviyoOnsiteSubscriptionEmail } from 'utils/klaviyo-client-api';

type KlaviyoFormsEvent = CustomEvent<{
  type: string;
  formId?: string;
  metaData?: {
    email?: string;
  };
}>;

const installKlaviyoFormsListener = (): void => {
  window.addEventListener('klaviyoForms', (event) => {
    const detail = (event as KlaviyoFormsEvent).detail;
    if (detail.type !== 'submit') return;

    publishFormSubmitted('klaviyo', detail.metaData?.email, detail.formId);
  });
};

const installKlaviyoSubscriptionEmailFallback = (): void => {
  watchKlaviyoOnsiteSubscriptionEmail((email) => {
    publishFormSubmitted('klaviyo', email);
  });
};

installKlaviyoFormsListener();
installKlaviyoSubscriptionEmailFallback();
